'use strict';

import angular from 'angular';

const GrpTypeResource = ['$resource', function($resource) {
  return $resource('/api/groups/:groupId/types/:id/:controller', {
    id: '@id'
  }, {
    getType: {
      method: 'GET',
      params: { id: 'own' }
    },
    getDesc: {
      method: 'GET',
      isArray: true,
      params: { id: 'descendents' }
    },
    getDefinedBy: { // same as query
      method: 'GET',
      isArray: true
    }
  });
}];

export default angular.module('georgeApp.grpTypeSvc', [])
  .factory('GrpTypeSvc', GrpTypeResource)
  .name;
